import * as React from 'react';
import ReactDom from 'react-dom';

// 弹出层
export default class RenderInBody extends React.Component {
  popup: HTMLDivElement = document.createElement('div');

  componentDidMount() {
    // 新建一个 div 标签并塞进 body
    document.body.appendChild(this.popup);
    this._renderLayer();
  }
  componentDidUpdate() {
    this._renderLayer();
  }
  componentWillUnmount() {
    // 在组件卸载的时候，保证弹层也被卸载掉
    ReactDom.unmountComponentAtNode(this.popup);
    document.body.removeChild(this.popup);
  }
  _renderLayer() {
    // 将弹层渲染到body下的div标签
    const { children } = this.props;
    if (React.isValidElement(children)) {
      ReactDom.render(children, this.popup);
    }
  }
  render() {
    return null;
  }
}
